var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 187,
    viewBox: "0 0 212 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.66,
    d: "M90.8217 147.471L148.214 155.082C211.519 147.475 216.832 87.6286 208.597 65.0677C191.2 17.4066 152.671 38.342 143.347 40.0588C125.776 43.2935 104.364 36.3417 84.2046 23.916C64.0448 11.4903 24.182 14.1609 7.00092 46.7618C-10.1802 79.3628 5.13297 149.305 65.7684 150.265L90.8217 147.471Z",
    fill: "#E5E7EB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M187.533 84.0714C183.023 53.4678 95.7774 54.4525 85.7127 41.5916C75.1149 28.0504 96.752 15.9806 126.632 9.65131",
    stroke: "#434343",
    strokeWidth: 1.305,
    strokeMiterlimit: 10,
    strokeDasharray: "6.52 8.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.84,
    d: "M93.5309 147.863L142.739 155.451C206.36 148.774 204.72 89.5202 201.017 77.4186C188.323 35.9259 146.559 54.5655 138.564 56.0326C123.497 58.7969 105.137 52.8521 87.8492 42.2277C70.5614 31.6033 36.3986 32.2615 18.9427 58.5129C0.662479 86.0036 20.0554 149.427 72.0488 150.251L93.5309 147.863Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.34,
    d: "M113.042 177.456C113.042 174.999 97.6164 174.49 78.5881 174.49C59.5598 174.49 44.1342 174.999 44.1342 177.456C44.1342 178.261 45.7988 178.888 48.6954 179.368C47.8609 179.716 47.4026 180.128 47.4026 180.62C47.4026 183.077 58.6823 183.883 72.596 183.883C86.5096 183.883 97.7893 183.077 97.7893 180.62C97.7893 180.524 97.7657 180.431 97.7314 180.34C106.963 179.89 113.042 178.999 113.042 177.456Z",
    fill: "#FFB9A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.94,
    d: "M198.014 162.771C198.014 156.817 157.037 155.583 106.49 155.583C55.9423 155.583 14.9659 156.817 14.9659 162.771C14.9659 167.37 39.4127 170.533 73.83 171.735C48.6806 171.829 29.009 172.739 29.009 176.326C29.009 177.574 31.4043 178.546 35.5725 179.29C34.3719 179.829 33.7122 180.469 33.7122 181.231C33.7122 185.041 49.9434 186.29 69.9656 186.29C89.9877 186.29 106.219 185.041 106.219 181.231C106.219 181.081 106.185 180.937 106.135 180.797C119.419 180.099 128.167 178.717 128.167 176.326C128.167 174.07 120.385 172.873 108.353 172.272C158.04 172.186 198.014 168.652 198.014 162.771Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.6,
    d: "M175.439 162.608C175.439 166.615 143.792 169.002 104.754 169.002C65.7152 169.002 34.068 166.615 34.068 162.608C34.068 158.602 65.7152 157.772 104.754 157.772C143.792 157.772 175.439 158.602 175.439 162.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M135.1 142.448C135.1 142.448 145.846 120.06 165.846 110.21C165.846 110.21 181.965 110.807 194.203 132L168.831 124.239C168.831 124.239 147.339 141.552 135.996 147.224L135.1 142.448Z",
    fill: "#959595",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.58,
    d: "M166.929 116.667C149.966 125.021 138.578 141.309 135.84 146.392L135.996 147.224C147.339 141.552 168.831 124.239 168.831 124.239L193.172 131.685C181.188 115.334 166.929 116.667 166.929 116.667Z",
    fill: "#959595",
    fillOpacity: 0.29
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M146.285 164.226H74.6358C71.701 164.226 69.3221 161.847 69.3221 158.912V31.8573C69.3221 28.9225 71.701 26.5436 74.6358 26.5436H146.284C149.219 26.5436 151.598 28.9225 151.598 31.8573V158.912C151.598 161.847 149.219 164.226 146.285 164.226Z",
    fill: "#2C706C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M146.285 164.226H74.6358C71.701 164.226 69.3221 161.847 69.3221 158.912V31.8573C69.3221 28.9225 71.701 26.5436 74.6358 26.5436H146.284C149.219 26.5436 151.598 28.9225 151.598 31.8573V158.912C151.598 161.847 149.219 164.226 146.285 164.226Z",
    fill: "#2C706C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M141.951 164.226H70.3016C67.3668 164.226 64.9879 161.847 64.9879 158.912V31.8573C64.9879 28.9225 67.3668 26.5436 70.3016 26.5436H141.95C144.885 26.5436 147.264 28.9225 147.264 31.8573V158.912C147.264 161.847 144.885 164.226 141.951 164.226Z",
    fill: "#2C706C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M144.4 40.5036H67.8527V147.123H144.4V40.5036Z",
    fill: "#51C4BE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M137.795 33.4896C137.795 34.9127 136.641 36.0665 135.218 36.0665C133.794 36.0665 132.641 34.9127 132.641 33.4896C132.641 32.0664 133.794 30.9127 135.218 30.9127C136.641 30.9127 137.795 32.0664 137.795 33.4896Z",
    fill: "#2C706C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M131.127 33.4896C131.127 34.2661 130.498 34.8958 129.721 34.8958C128.944 34.8958 128.315 34.2661 128.315 33.4896C128.315 32.713 128.944 32.0833 129.721 32.0833C130.498 32.0833 131.127 32.713 131.127 33.4896Z",
    fill: "#2C706C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M120.242 34.5057H92.0111C91.4755 34.5057 91.0414 34.0715 91.0414 33.5359C91.0414 33.0004 91.4755 32.5662 92.0111 32.5662H120.242C120.777 32.5662 121.211 33.0004 121.211 33.5359C121.211 34.0715 120.777 34.5057 120.242 34.5057Z",
    fill: "#2C706C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    opacity: 0.26,
    d: "M101.278 107.181H73.7434C71.9918 107.181 70.572 105.762 70.572 104.01V87.8426C70.572 86.091 71.9918 84.6712 73.7434 84.6712H101.278C103.03 84.6712 104.45 86.091 104.45 87.8426V104.01C104.45 105.762 103.03 107.181 101.278 107.181Z",
    fill: "#2C706C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    opacity: 0.26,
    d: "M137.508 107.181H109.973C108.222 107.181 106.802 105.762 106.802 104.01V87.8426C106.802 86.091 108.222 84.6712 109.973 84.6712H137.508C139.26 84.6712 140.68 86.091 140.68 87.8426V104.01C140.679 105.762 139.259 107.181 137.508 107.181Z",
    fill: "#2C706C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    opacity: 0.15,
    d: "M147.264 93.7864V31.8573C147.264 28.9225 144.885 26.5436 141.95 26.5436H91.5016L147.264 93.7864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.9,
    d: "M102.904 105.556H75.3689C73.6173 105.556 72.1975 104.136 72.1975 102.384V86.217C72.1975 84.4655 73.6173 83.0456 75.3689 83.0456H102.904C104.656 83.0456 106.075 84.4655 106.075 86.217V102.384C106.075 104.136 104.655 105.556 102.904 105.556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    opacity: 0.26,
    d: "M151.143 49.5938H98.3572C96.3579 49.5938 94.7367 51.2145 94.7367 53.2143L89.8949 65.3222L94.7367 61.4945V71.8857C94.7367 73.885 96.3574 75.5062 98.3572 75.5062H151.143C153.142 75.5062 154.763 73.885 154.763 71.8857V53.2143C154.763 51.2145 153.142 49.5938 151.143 49.5938Z",
    fill: "#2C706C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    opacity: 0.9,
    d: "M139.133 105.556H111.598C109.847 105.556 108.427 104.136 108.427 102.384V86.217C108.427 84.4655 109.847 83.0456 111.598 83.0456H139.133C140.885 83.0456 142.305 84.4655 142.305 86.217V102.384C142.305 104.136 140.885 105.556 139.133 105.556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    opacity: 0.9,
    d: "M152.226 47.9682H99.4405C97.7976 47.9682 96.4125 49.0635 95.9697 50.5625L95.9282 50.4505L90.9781 63.6962L95.82 59.8685V70.2597C95.82 72.259 97.4407 73.8802 99.4405 73.8802H152.226C154.225 73.8802 155.846 72.2595 155.846 70.2597V51.5882C155.846 49.5894 154.226 47.9682 152.226 47.9682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    opacity: 0.26,
    d: "M161.124 116.606H110.505C108.506 116.606 106.885 118.227 106.885 120.227L102.043 132.335L106.885 128.507V138.899C106.885 140.898 108.506 142.519 110.505 142.519H161.123C163.123 142.519 164.744 140.898 164.744 138.899V120.227C164.744 118.227 163.123 116.606 161.124 116.606Z",
    fill: "#2C706C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    opacity: 0.9,
    d: "M161.665 114.981H111.047C109.328 114.981 107.892 116.18 107.522 117.786L107.481 117.68L102.585 130.709L107.427 126.882V137.273C107.427 139.272 109.048 140.894 111.048 140.894H161.666C163.665 140.894 165.286 139.273 165.286 137.273V118.602C165.286 116.602 163.665 114.981 161.665 114.981Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    opacity: 0.26,
    d: "M115.199 160.412H94.3113C92.0478 160.412 90.2131 158.577 90.2131 156.314C90.2131 154.05 92.0478 152.216 94.3113 152.216H115.199C117.462 152.216 119.297 154.05 119.297 156.314C119.297 158.577 117.462 160.412 115.199 160.412Z",
    fill: "#2C706C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M66.6358 67.4804L63.2007 60.7059C63.2007 60.7059 58.6544 61.8509 55.766 68.6404C52.8781 75.4294 52.8738 89.3396 52.8738 89.3396C52.8738 89.3396 57.0405 95.7722 62.6086 97.0023C68.1768 98.2323 68.4941 86.1369 68.4941 86.1369L66.6358 67.4804Z",
    fill: "#E09234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    opacity: 0.47,
    d: "M71.5115 67.4804L68.0764 60.7059C68.0764 60.7059 63.5302 61.8509 60.6418 68.6404C57.7539 75.4294 57.7495 89.3396 57.7495 89.3396C57.7495 89.3396 61.9162 95.7722 67.4844 97.0023C73.0525 98.2323 73.3698 86.1369 73.3698 86.1369L71.5115 67.4804Z",
    fill: "#E09234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M106.096 71.2371C106.096 71.2371 107.477 70.3828 107.606 69.8067C107.736 69.2305 107.838 65.964 109.121 65.0064C110.405 64.0487 111.238 63.6662 111.493 64.1796C111.748 64.6929 110.401 65.5221 110.463 66.4832C110.525 67.4442 111.614 67.1906 112.127 66.8714C112.369 66.7212 112.865 66.3151 113.323 65.9278C113.937 65.4077 114.347 64.691 114.5 63.9009C114.708 62.8279 115.052 61.4578 115.411 61.779C115.987 62.2928 115.79 62.8105 115.787 64.2197C115.784 65.6289 115.264 67.8407 115.264 67.8407C115.264 67.8407 114.553 70.4654 113.781 71.4882C113.01 72.5111 109.009 74.153 109.009 74.153L106.096 71.2371Z",
    fill: "#FFA087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M74.7331 99.8906L70.9426 131.406L56.5315 166.977L57.9238 175.866C57.9238 175.866 63.9908 178.735 61.625 179.396C59.2591 180.057 58.9027 179.866 57.283 179.643C55.6627 179.42 53.886 178.29 53.886 178.29C53.886 178.29 50.4317 172.237 49.9091 171.501C49.3866 170.765 46.687 168.48 49.2113 166.424C49.7334 166 50.1873 165.564 50.5712 165.056C51.7293 163.524 52.2538 161.327 52.1031 156.745C51.9036 150.691 73.9101 89.9336 73.9101 89.9336L74.7331 99.8906Z",
    fill: "#FFA087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M76.4977 38.8969C76.4977 38.8969 79.1779 39.8816 80.0467 42.3551C80.6431 44.0536 80.5171 45.6323 80.3794 46.4547C80.3157 46.8348 80.3751 47.2168 80.5538 47.5582C80.9812 48.3748 81.4646 50.5857 80.6692 52.1571C79.5614 54.3453 78.4656 57.2718 76.1302 57.3273C73.7947 57.3829 71.9712 55.7008 71.9712 55.7008L68.9872 44.8852L76.4977 38.8969Z",
    fill: "#FFA087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M61.4873 91.0511C52.3044 96.7714 55.6642 113.3 57.4983 119.129C59.3325 124.957 59.0263 127.487 55.1663 132.255C50.0482 138.578 51.3989 150.076 51.9422 156.892C54.2646 158.248 57.2003 159.827 60.0545 160.991L70.9425 134.114L74.7325 102.599L73.9101 92.6419L61.4873 91.0511Z",
    fill: "#3C3642"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M67.3558 108.578L63.7981 105.146C63.7981 105.146 67.8977 122.844 67.8977 127.54C67.8977 132.235 64.0328 151.559 64.0328 151.559L70.9971 134.115L73.3151 114.717L67.3558 108.578Z",
    fill: "#3C3642"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M74.3804 52.8463C74.3804 52.8463 73.7777 60.8831 75.2541 62.4391C76.7304 63.9951 71.3979 64.2052 71.3979 64.2052L68.0159 64.1163L65.695 60.7885C65.695 60.7885 66.9071 57.435 66.6063 55.5598C66.3054 53.6846 64.1293 48.9012 64.0245 47.2057C63.7787 43.2312 64.9233 39.643 68.5694 38.5719C72.2155 37.5008 75.2478 37.58 76.4971 38.8969C77.7464 40.2134 75.8254 46.6986 75.8254 46.6986L74.3804 52.8463Z",
    fill: "#FFA087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M79.4879 91.564C79.4879 91.564 93.8796 125.06 93.6811 132.635C93.457 141.165 91.8639 172.602 91.8639 172.602C91.8639 172.602 105.062 179.091 102.701 179.571C100.34 180.051 89.1469 179.757 87.5267 179.534C85.9065 179.31 85.0184 178.745 85.0469 177.662C85.0753 176.579 85.7258 172.441 85.7258 172.441C85.7258 172.441 79.6675 155.481 78.5602 149.49C77.4528 143.499 79.2768 135.96 78.9963 132.881C78.7157 129.803 75.4612 121.949 71.2467 117.322C67.0327 112.695 61.6683 103.688 63.996 97.6069C66.3238 91.5259 66.5135 92.2671 66.5135 92.2671L79.4879 91.564Z",
    fill: "#FFA087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M93.6811 132.635C93.88 125.06 79.4878 91.564 79.4878 91.564L66.5135 92.2671C66.5135 92.2671 65.1372 93.006 62.8094 99.087C60.4817 105.168 66.9351 112.363 70.8724 117.228C74.9802 122.304 78.7156 129.802 78.9962 132.881C79.2768 135.96 77.4528 143.499 78.5601 149.49C78.9986 151.862 80.2142 155.955 81.5219 160.034C84.5933 160.219 88.492 160.109 92.5302 159.105C92.9953 149.482 93.555 137.433 93.6811 132.635Z",
    fill: "#3C3642"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M84.9266 72.1561L80.0393 92.4057C80.0393 92.4057 71.9532 95.5023 60.6749 91.593L58.9021 72.5565L59.3816 64.9093C59.4777 63.3746 60.3963 62.0219 61.7726 61.3371C62.9428 60.7547 64.3075 60.2379 65.1821 60.4369C65.1821 60.4369 70.1702 63.1114 74.7643 60.1607C74.7643 60.1607 82.1188 62.146 83.1547 63.9797C84.1896 65.8138 84.9266 72.1561 84.9266 72.1561Z",
    fill: "#E09234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M78.9196 77.0829L82.9926 80.4248L82.1571 83.558L78.9196 77.0829Z",
    fill: "#E09234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M75.6384 68.1183L79.0585 61.7046C79.0585 61.7046 81.0946 60.69 88.45 69.3624C93.9115 75.8017 94.0336 76.189 94.0336 76.189L106.531 69.9535L111.07 74.1071C111.07 74.1071 99.5033 86.1185 93.0035 86.2648C85.5925 86.4314 73.757 70.9594 73.757 70.9594L75.2487 69.1919",
    fill: "#E09234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M91.8633 172.602C89.3999 172.984 87.6083 173.205 85.6374 172.632C85.4592 173.802 85.0681 176.826 85.0463 177.661C85.0178 178.744 85.9064 179.31 87.5262 179.533C89.1464 179.756 100.339 180.05 102.7 179.57C105.062 179.09 91.8633 172.602 91.8633 172.602Z",
    fill: "#3C3642"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M77.6228 37.9731C78.8426 38.5492 79.8974 39.9458 79.7081 41.2816C79.4743 42.9318 78.2414 43.9454 75.8258 45.5067C71.4384 48.342 73.7164 54.8567 74.632 58.9031C76.4864 67.1003 77.3518 74.8629 72.9422 82.4912C71.6316 84.7586 69.9157 86.8704 67.631 88.1511C63.0229 90.7334 54.9638 90.9111 50.3741 88.2695C46.6932 86.1514 44.5838 81.8982 44.253 77.6639C43.7691 71.4713 46.7135 66.3455 51.1632 62.3218C54.733 59.0939 59.8182 56.2002 59.5454 50.745C59.1291 42.4237 66.6125 32.771 77.6228 37.9731Z",
    fill: "#3C3642"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    opacity: 0.51,
    d: "M75.8258 45.5067C76.9848 44.7577 77.8691 44.1342 78.5036 43.5064C77.941 43.8252 77.2818 44.1468 76.5111 44.5008C71.7639 46.6817 73.09 53.4543 73.4194 57.5901C74.0863 65.9679 73.8361 73.7744 68.3839 80.6962C66.7637 82.7535 64.7639 84.5992 62.3202 85.5409C57.7122 87.3162 50.419 86.5802 46.0842 83.8058C47.1114 85.6433 48.5486 87.2191 50.3741 88.2695C54.9638 90.9106 63.0234 90.7334 67.631 88.1511C69.9152 86.8709 71.6316 84.7586 72.9422 82.4912C77.3518 74.8629 76.4864 67.1003 74.632 58.9031C73.7164 54.8567 71.4384 48.342 75.8258 45.5067Z",
    fill: "#3C3642"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M75.498 46.3403C75.498 46.3403 75.0904 45.1344 73.4643 45.302C71.8364 45.47 70.8536 49.9091 74.5041 50.0888C74.5041 50.0888 75.0256 49.9584 75.0421 49.5508",
    fill: "#FFA087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M56.5319 166.978L58.141 175.867C58.141 175.867 63.5556 178.417 62.6964 179.383C61.8373 180.349 57.2099 180.955 53.8864 178.29C50.5624 175.625 47.8783 169.289 47.8783 169.289C47.8783 169.289 47.4171 168.117 48.5568 167.037C49.6965 165.958 50.5721 165.056 50.5721 165.056C50.5721 165.056 52.6689 168.436 56.5319 166.978Z",
    fill: "#3C3642"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M131.162 3.85859L150.013 1.48597L127.725 0L131.162 3.85859Z",
    fill: "#E09234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M131.162 3.85859L130.581 10.2535L149.483 1.46568L131.162 3.85859Z",
    fill: "#E09234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    opacity: 0.45,
    d: "M131.162 3.85859L130.581 10.2535L149.483 1.46568L131.162 3.85859Z",
    fill: "#E09234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M132.155 5.05866L130.581 10.2535L150.013 1.48596L132.155 5.05866Z",
    fill: "#E09234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    opacity: 0.2,
    d: "M132.155 5.05866L130.581 10.2535L150.013 1.48596L132.155 5.05866Z",
    fill: "#E09234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M137.184 10.38L132.156 5.05866L150.013 1.48596L137.184 10.38Z",
    fill: "#E09234"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M68.2043 161.13C68.2043 161.13 61.3887 134.587 137.601 116.608C172.406 108.397 189.591 98.0396 187.533 84.0714",
    stroke: "#434343",
    strokeWidth: 1.305,
    strokeMiterlimit: 10,
    strokeDasharray: "6.52 8.24"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartChat);
export default __webpack_public_path__ + "static/media/start-chat.60072f9977f4b6507952f98192d57edb.svg";
export { ForwardRef as ReactComponent };